import React from 'react';
import './Encabezado.css';

// Logos
import logoGyF from '../img/logo_gol_y_futbol_claro.svg';

// styled-components
import styled from 'styled-components';
import { Row, Col } from 'reactstrap';

export function Introduccion(props) {
  const SLogoLinkBig = styled.a`
    display: block;
    height: 100%;
    width: 100%;
    /* align-self: center; */
    > img {
      display: block;
      align-self: center;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    > img:hover {
      filter: drop-shadow(0 0 5px #faca15);
    }
    > img:active {
      filter: drop-shadow(0 0 5px #faca15);
    }
  `;
  const SLogoLinkSmall = styled.a`
    display: block;
    height: 100%;
    width: 100%;
    align-self: center;
    > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    > img:hover {
      filter: drop-shadow(0 0 5px #faca15);
    }
    > img:active {
      filter: drop-shadow(0 0 5px #faca15);
    }
  `;
  const TitleBig = styled.h1`
    font-size: 2em;
    margin: none;
  `;
  const TitleSmall = styled.h1`
    font-size: 1.5em;
    margin: none;
  `;
  const Divider = styled.div`
    border: none;
    border-left: 1px solid white;
    padding-left: 1em;
    height: 100%;
  `;
  return (
    <div>
      <Row className="align-items-center justify-content-between d-flex d-md-none">
        <Col xs={2} sm={1} style={{ paddingRight: '0' }}>
          <SLogoLinkSmall href="//www.golyfutbol.com">
            <img src={logoGyF} alt="Gol y Fútbol" />
          </SLogoLinkSmall>
        </Col>
        <Col xs={10} sm={11}>
          <TitleSmall>{props.titulo}</TitleSmall>
        </Col>
      </Row>

      <Row className="d-none d-md-flex align-items-center">
        <Col md={1} lg={1} style={{ paddingRight: '0' }}>
          <SLogoLinkBig href="//www.golyfutbol.com">
            <img src={logoGyF} alt="Gol y Fútbol" />
          </SLogoLinkBig>
        </Col>
        <Col md={11} lg={11}>
          <Divider>
            <TitleBig>{props.titulo}</TitleBig>
          </Divider>
        </Col>
      </Row>
    </div>
  );
}

export function Encabezado(props) {
  const Background = styled.div`
    box-sizing: border-box !important;
    border-left: 0.5em solid #faca15;
    overflow: auto;
    background: #1c7ca2;
    margin: none;
    width: 100%;
    padding: 1em;
    > * {
      color: white;
    }
  `;
  return (
    <Background>
      <Introduccion titulo={props.titulo} />
    </Background>
  );
}



// WEBPACK FOOTER //
// ./src/components/Encabezado.js